module.exports = __webpack_public_path__ + "static/media/footer_logo.a9f11328.png";